import React from "react";
import Button from "@mui/material/Button";
import LinearProgress from '@mui/material/LinearProgress';
import Box from "@mui/material/Box";

export function formatCell(columns) {
  return columns.map((col) => {
    if (col?.render) {
      switch (col.render) {
        case "image":
          return {
            ...col,
            renderCell: (params) => (
              <div
                style={{
                  padding: "15px 0",
                  lineHeight: "normal",
                }}
              >
                <img
                  src={params.row[col.field]}
                  style={{ width: "24px", height: "24px" }}
                />
              </div>
            ),
          };
        case 'button':
          return {
            ...col,
            renderCell: (params) => (
              <Button
                variant="outlined"
                onClick={() => {
                  window.open(params.row[col.field], ((col?.renderOptions?.target) ? col.renderOptions.target : '_blank'));
                }}
              >
                {(col?.renderOptions?.label) ? col.renderOptions.label : col.headerName}
              </Button>
            ),
          };
          case 'progress':
            return {
              ...col,
              display:'flex',
              renderCell: (params) => (
              <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                <LinearProgress variant="determinate" value={params.row[col.field] * 100} style={{ width: '100%' }} />
              </Box>
              ),
            };
      }
    }
    return col;
  })
}
